import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features2.css'

const Features2 = (props) => {
  return (
    <div
      className={`features2-layout302 thq-section-padding ${props.rootClassName} `}
    >
      <div className="features2-max-width thq-section-max-width">
        <div className="features2-section-title thq-flex-column">
          <h2 className="thq-heading-2">
            {props.sectionTitle ?? (
              <Fragment>
                <span className="features2-text8">Key Features</span>
              </Fragment>
            )}
          </h2>
          <p className="thq-body-large">
            {props.sectionDescription ?? (
              <Fragment>
                <span className="features2-text9">
                  Discover the innovative features that set Signbridge AI apart
                  in revolutionizing accessibility.
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <div className="features2-content1">
          <div className="thq-grid-5">
            <div className="features2-feature1 thq-flex-column">
              <img
                alt={props.feature1ImageAlt}
                src={props.feature1ImageSrc}
                className="features2-image1 thq-team-image-round"
              />
              <div className="thq-flex-column">
                <span className="thq-body-small">
                  {props.feature1Description ?? (
                    <Fragment>
                      <span className="features2-text4">Prop Content</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="features2-feature2 thq-flex-column">
              <img
                alt={props.feature2ImageAlt}
                src={props.feature2ImageSrc}
                className="features2-image2 thq-team-image-round"
              />
              <div className="thq-flex-column">
                <span className="thq-body-small">
                  {props.feature2Description ?? (
                    <Fragment>
                      <span className="features2-text6">Prop Content</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="features2-feature3 thq-flex-column">
              <img
                alt={props.feature3ImageAlt}
                src={props.feature3ImageSrc}
                className="features2-image3 thq-team-image-round"
              />
              <div className="thq-flex-column">
                <span className="thq-body-small">
                  {props.feature3Description ?? (
                    <Fragment>
                      <span className="features2-text7">Prop Content</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="features2-feature4 thq-flex-column">
              <img
                alt={props.feature4ImageAlt}
                src={props.feature4ImageSrc}
                className="features2-image4 thq-team-image-round"
              />
              <div className="thq-flex-column">
                <span className="thq-body-small">
                  {props.feature4Description ?? (
                    <Fragment>
                      <span className="features2-text5">
                        Collaborate with us to bring cutting-edge accessibility
                        solutions to governments and enterprises.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="features2-feature5 thq-flex-column">
              <img
                alt={props.feature5ImageAlt}
                src={props.feature5ImageSrc}
                className="features2-image5 thq-team-image-round"
              />
              <div className="thq-flex-column">
                <span className="thq-body-small">
                  {props.feature5Description ?? (
                    <Fragment>
                      <span className="features2-text3">
                        Tailor our AI technology to meet the specific needs of
                        your organization for enhanced accessibility.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="features2-actions"></div>
        </div>
      </div>
    </div>
  )
}

Features2.defaultProps = {
  feature3ImageSrc:
    'https://images.unsplash.com/photo-1730367796069-f8272f5249bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNnw&ixlib=rb-4.0.3&q=80&w=200',
  feature4ImageAlt: 'Partnership Opportunities',
  feature1ImageAlt: 'Real-time Sign Language Translation',
  feature5Description: undefined,
  feature1ImageSrc:
    'https://images.unsplash.com/photo-1591621839477-83880c7ec521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNXw&ixlib=rb-4.0.3&q=80&w=200',
  feature5ImageSrc:
    'https://images.unsplash.com/photo-1700208505264-2e3067a3fc9c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNXw&ixlib=rb-4.0.3&q=80&w=200',
  feature3ImageAlt: 'Deaf Community Engagement',
  feature1Description: undefined,
  feature4Description: undefined,
  feature2Description: undefined,
  feature4ImageSrc:
    'https://images.unsplash.com/photo-1699602049631-57a2e3dada16?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNXw&ixlib=rb-4.0.3&q=80&w=200',
  feature3Description: undefined,
  sectionTitle: undefined,
  feature2ImageSrc:
    'https://images.unsplash.com/photo-1677447807174-60a70de4a63e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczOTQwODUzNnw&ixlib=rb-4.0.3&q=80&w=200',
  feature2ImageAlt: 'VR/AR Integration',
  feature5ImageAlt: 'Customizable Solutions',
  sectionDescription: undefined,
  rootClassName: '',
}

Features2.propTypes = {
  feature3ImageSrc: PropTypes.string,
  feature4ImageAlt: PropTypes.string,
  feature1ImageAlt: PropTypes.string,
  feature5Description: PropTypes.element,
  feature1ImageSrc: PropTypes.string,
  feature5ImageSrc: PropTypes.string,
  feature3ImageAlt: PropTypes.string,
  feature1Description: PropTypes.element,
  feature4Description: PropTypes.element,
  feature2Description: PropTypes.element,
  feature4ImageSrc: PropTypes.string,
  feature3Description: PropTypes.element,
  sectionTitle: PropTypes.element,
  feature2ImageSrc: PropTypes.string,
  feature2ImageAlt: PropTypes.string,
  feature5ImageAlt: PropTypes.string,
  sectionDescription: PropTypes.element,
  rootClassName: PropTypes.string,
}

export default Features2
